import { render, staticRenderFns } from "./SortableLeaderboard.vue?vue&type=template&id=0433b162&"
import script from "./SortableLeaderboard.vue?vue&type=script&lang=js&"
export * from "./SortableLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./SortableLeaderboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports